<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0073_excess_deficiency_summary</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-search title="過不足集計表" ></title-and-search>
          <br>
          <div class="row" :style="'margin-top:3px;margin-bottom:30px;'">
            <div class="col-xs-4">
              <search-company @search="onCopmanySearchEvent" :only_company="true"/>
            </div>
          </div>
          <tabs nav-style="tabs" @active="onTabChanged($event)" :value="selectedTab">
            <tab header="部署" data-test="123" ></tab>
            <tab header="チーム" ></tab>
            <tab header="システム" ></tab>
            <tab header="全体" ></tab>
          </tabs>
          <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
          <div style="margin-top:5px;">
            <button
            :disabled="formExportFileDisabled || checkUserPermission(true,permissionMode.EDIT) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #b83261;background: #337ab7;"
            @click="initExportFile" >出力</button>
            <file-download-modal tag="runExcessDeficiencySummaryDownloadModal" @close="onCloseExportFile"/>
          </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_excess_deficiency_summary';
import { utils } from '@/libs/utils';
import { tab, tabs } from "vue-strap/dist/vue-strap.js";


import _debug from 'debug';
var mdebug = _debug('esma:master_user');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
import fileDownloadModal from '@/components/modals/file-download-modal';
import searchCompany from "@/components/search-company";

export default {
  mixins: [mixinPageCommon,mixinDatasource],
  components: {
    'ag-grid-vue': AgGridVue,
    'file-download-modal':fileDownloadModal,
    tab,
    tabs,
    "search-company":searchCompany
  },
  data() {
    return {
      api_name:"excess_deficiency_summary",
      page_acl: acl.master,
      execute_filter_on_back:true,
      link_to_open:"#",
      selected_tab:0,
      company:null
    };
  },
  computed: {
    selectedTab:{
      get(){
        return this.selected_tab;
      },
      set(v){
        this.selected_tab = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() { // 部署名
      return [
        utils.extend(fields.department, {}),          // 部署名
        utils.extend(fields.item_number, {}),         // 総本数
        utils.extend(fields.number_to_be_linked, {}), // 紐付対象数
        utils.extend(fields.number_of_link, {}),      // 紐付数
        utils.extend(fields.number_of_unlinked, {}),  // 未紐付数
        utils.extend(fields.linking_rate, {suppressSorting:true}),        // 紐付率
      ];
    },
    tabFieldList1() {//チーム名
      return [
        utils.extend(fields.department, {}),          // 部署名
        utils.extend(fields.team, {}),                // チーム名
        utils.extend(fields.item_number, {}),         // 総本数
        utils.extend(fields.number_to_be_linked, {}), // 紐付対象数
        utils.extend(fields.number_of_link, {}),      // 紐付数
        utils.extend(fields.number_of_unlinked, {}),  // 未紐付数
        utils.extend(fields.linking_rate, {suppressSorting:true}),        // 紐付率
      ];
    },
    tabFieldList2() {//システム名
      return [
        utils.extend(fields.system_name, {}),         // システム名
        utils.extend(fields.department, {}),          // 部署名
        utils.extend(fields.item_number, {}),         // 総本数
        utils.extend(fields.number_to_be_linked, {}), // 紐付対象数
        utils.extend(fields.number_of_link, {}),      // 紐付数
        utils.extend(fields.number_of_unlinked, {}),  // 未紐付数
        utils.extend(fields.linking_rate, {suppressSorting:true}),        // 紐付率
      ];
    },
    tabFieldList3() { //All
      return [
        utils.extend(fields.department, {}),          // 部署名
        utils.extend(fields.item_number, {}),         // 総本数
        utils.extend(fields.number_to_be_linked, {}), // 紐付対象数
        utils.extend(fields.number_of_link, {}),      // 紐付数
        utils.extend(fields.number_of_unlinked, {}),  // 未紐付数
        utils.extend(fields.linking_rate, {suppressSorting:true}),        // 紐付率
      ];
    },

    linkToOpen:{
      get(){
        return this.link_to_open;
      },
      set(v){
        this.link_to_open = v;
      }
    },
  },
  methods: {
    onCopmanySearchEvent(obj){
      this.company = obj.val;
      this.onTabChanged(this.selectedTab)
    },
    onTabChanged(index) {
      this.selectedTab = index;
      this.clearSearchFields();
      switch (index) {
        case 0:
          this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList"))
          this.api_request_options = {filter_mode:"department", company:this.company};
          break;
        case 1:
          this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList1"))
          this.api_request_options = {filter_mode:"team", company:this.company};
          break;
        case 2:
          this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList2"))
          this.api_request_options = {filter_mode:"system", company:this.company};
          break;
        case 3:
        default:
          this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList3"))
          this.api_request_options = {filter_mode:"all", company:this.company};
          break;
      }
      this.gridOptions.api.sizeColumnsToFit();
      this.emulateSearchControlChangedDatasource(true)

    },
    initExportFile(){
      bus.$emit("runExcessDeficiencySummaryDownloadModal",{
        message: "ファイルを出力しています。",
        on_complete_message:"出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        api_request_options: this.api_request_options,
        url:"/" + this.api_name + "/export_data/"
      });
    },
    onCloseExportFile(){},
    onDetailsClick(ev, data) {
    },
    createColumnDefs(field_list_name="tabFieldList") {
      return this.commonCreateColumnDefs({show_details:false,show_checkbox:false,field_list_name})
    },
    onRowSelected(ev){
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {
  },
  beforeMount() {
    // this.$store.state[this.stateCurrentRow]= {};
    this.count_from_result = false;
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.api_request_options = {filter_mode:"department", company:null};
    this.initDatasource({load_only_with_filter:false});
    // setTimeout(() => {
    //   this.emulateSearchControlChangedDatasource(true);
    // }, 500);
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0073_excess_deficiency_summary.vue?c8cd9350